/*!

=========================================================
* Vision UI Free React - v1.0.0
=========================================================

* Product Page: https://www.creative-tim.com/product/vision-ui-free-react
* Copyright 2021 Creative Tim (https://www.creative-tim.com/)
* Licensed under MIT (https://github.com/creativetimofficial/vision-ui-free-react/blob/master LICENSE.md)

* Design and Coded by Simmmple & Creative Tim

=========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.

*/

// Vision UI Dashboard React Base Styles
import colors from "assets/theme/base/colors";
import typography from "assets/theme/base/typography";
import borders from "assets/theme/base/borders";

// Vision UI Dashboard helper functions
import pxToRem from "assets/theme/functions/pxToRem";

const { white, grey, inputColors } = colors;
const { size, fontWeightRegular } = typography;
const { borderRadius } = borders;

export default {
  styleOverrides: {
    root: {
      display: "flex !important",
      alignItems: "center !important",
      width: "100% !important",
      height: "auto !important",
      padding: `${pxToRem(8)} ${pxToRem(12)}`,
      fontSize: `${size.sm} !important`,
      fontWeight: `${fontWeightRegular} !important`,
      lineHeight: "1.4 !important",
      color: `${white.main} !important`,
      backgroundColor: "#0b1437 !important",
      backgroundClip: "padding-box !important",
      border: "1px solid rgba(255, 255, 255, 0.22) !important",
      appearance: "none !important",
      borderRadius: `${borderRadius.md} !important`,
      transition: "box-shadow 150ms ease, border-color 150ms ease, padding 150ms ease !important",

      "&.Mui-focused": {
        borderColor: "#0075ff !important",
        boxShadow: "0 0 0 2px rgba(0, 117, 255, 0.25) !important",
      },

      "&.Mui-disabled": {
        backgroundColor: "rgba(255, 255, 255, 0.05) !important",
        borderColor: "rgba(255, 255, 255, 0.1) !important",
        color: "rgba(255, 255, 255, 0.4) !important",
      },
    },

    input: {
      width: "100% !important",
      height: "auto !important",
      padding: "0 !important",
      color: "#ffffff !important",
      fontSize: "0.875rem !important",

      "&::placeholder": {
        color: "rgba(255, 255, 255, 0.5) !important",
        opacity: "1 !important",
      },
      "&::-webkit-input-placeholder": {
        color: "rgba(255, 255, 255, 0.5) !important",
      },
    },
  },
};
